/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const RetentionPolicyModifiable32 = (props: SVGProps) => (
    <AccessibleSVG width={32} height={32} viewBox="0 0 32 32" {...props}>
        <g fillRule="nonzero" fill="none">
            <path d="M6 0h20a6 6 0 016 6v20a6 6 0 01-6 6H6a6 6 0 01-6-6V6a6 6 0 016-6z" fill={vars.bdlLightBlue} />
            <path
                d="M21.808 8C22.467 8 23 8.585 23 9.308v14.384c0 .723-.533 1.308-1.192 1.308H9.174c-.181-.007-.286-.45.021-.546.353-.138.807-.876.807-1.55V9.27c0-.722.65-1.27 1.308-1.27h10.498zM9 20v3.01c0 .525-.447.99-1 .99-.553 0-1-.465-1-.99V20h2zm10.458-6.002l.013.002h-5.938c-.258 0-.524.221-.524.497 0 .246.19.452.43.495l.094.008h5.943c.285 0 .532-.231.532-.5a.505.505 0 00-.415-.488L19.499 14l-.041-.002zM19.5 12h-6l-.09.008a.5.5 0 000 .984l.09.008h6l.09-.008A.5.5 0 0019.5 12z"
                fill={vars.white}
            />
        </g>
    </AccessibleSVG>
);

export default RetentionPolicyModifiable32;
